import React, {useState} from "react";
import axios from 'axios';
import {useNavigate} from "react-router-dom";
import { toast } from 'react-toastify';
import RiseLoader from "react-spinners/RiseLoader";
import 'react-toastify/dist/ReactToastify.css';

const stylespinner = {
  position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
}

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [msg, setMsg] = useState("");    
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const saveLogin = async (e) =>{
        e.preventDefault();
        setLoading(true)
        let formData = new FormData();
            formData.append('email',email);
            formData.append('password',password);
        try {
            await axios.post(`${process.env.REACT_APP_MASTER_URL}/login`,formData,{
                headers:{ 
                    'Content-Type':'multipart/form-data'
                }
            });
            toast.info("Hai, Selamat Datang Kembali...");
            navigate("/")
        } catch (error) {
            setLoading(false)
            if(error.response){
               setMsg(error.response.data.msg);
            }
            
        }
            
    }

  return (
    <section className="hero has-background-grey-light is-fullheight is-fullwidth">
        {loading ?
            <div style={stylespinner}>
                <RiseLoader
                    color={'#301E67'}
                    loading={loading}
                    size={20}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
      <div className="hero-body">
        <div className="container">
            <div className="columns is-centered">
                <div className="column is-4-desktop">
                   <form className="box" onSubmit={saveLogin}>
                     <img src={`${process.env.REACT_APP_MASTER_URL2}/logonusamba.png`}  alt="Not Found" width={200} height={200}/>
                        <p style={{color:"red"}} className="has-text-centered">{msg}</p>
                        <div className="filed mt-5">
                            <label className="label">Username</label>
                            <div className="controls">
                                <input type="text" className="input" value={email} onChange={(e)=> setEmail(e.target.value)} placeholder="Username"/>
                            </div>
                        </div>
                        <div className="filed mt-5">
                            <label className="label">Password</label>
                            <div className="controls">
                                <input type="password" className="input" value={password} onChange={(e)=> setPassword(e.target.value)} placeholder="*****"/>
                            </div>
                        </div>
                        <div className="filed mt-5">
                            <button className="button is-link is-fullwidth">Login</button>
                        </div>
                    </form>
                </div>

            </div>
          
        </div>
      </div>
    }
    </section>
  )
}

export default Login